import React from 'react';
import ConsultationEditor from '../../doctor/ConsultationEditor';
import ConsultationPrescriptionPanel from '../../doctor/ConsultationPrescriptionPanel';
import { NURSE_COPY } from '../nurseCopy';
import '../../doctor/ConsultationEditorPage.css';

const W = NURSE_COPY.WORKSPACE;

/**
 * Étape examen infirmerie — même grille que le médecin :
 * dossier clinique (gauche) · ordonnance (panneau latéral droit).
 */
export default function NurseExamWorkspace({
  consultation,
  workSiteId,
  workSiteName = '',
  onCancel,
  onExamSuccess,
  onPrescriptionSuccess
}) {
  return (
    <section className="nr-exam-clinical nr-workspace__pane" aria-label={W.EXAM_TITLE}>
      <p className="nr-exam-clinical__intro small text-muted mb-3 mb-md-2">{W.EXAM_DESC}</p>

      <div className="consult-editor-layout consult-editor-layout--split">
        <main className="consult-editor-main">
          <ConsultationEditor
            consultation={consultation}
            viewerSiteId={workSiteId}
            clinicalWorkspace="nurse"
            showNursingVitals={false}
            onCancel={onCancel}
            onSuccess={onExamSuccess}
          />
        </main>

        <aside className="consult-editor-aside" aria-label={W.EXAM_COL_RX}>
          <section className="consult-side-panel consult-side-panel--rx">
            <div className="consult-side-panel__head">
              <span className="consult-side-panel__icon" aria-hidden>
                💊
              </span>
              <div>
                <h2 className="consult-side-panel__title">{W.EXAM_COL_RX}</h2>
                <p className="consult-side-panel__hint">Médicaments · posologie · pharmacie</p>
              </div>
            </div>
            <div className="consult-side-panel__body">
              {consultation?.id ? (
                <ConsultationPrescriptionPanel
                  consultation={consultation}
                  selectedSiteId={workSiteId}
                  selectedSiteName={workSiteName}
                  onPrescriptionSuccess={onPrescriptionSuccess}
                />
              ) : (
                <p className="consult-side-panel__placeholder">
                  Enregistrez le dossier clinique pour lier l&apos;ordonnance au passage.
                </p>
              )}
            </div>
          </section>
        </aside>
      </div>
    </section>
  );
}
